function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigit8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3.7820311mm",
    height: "5.9773459mm",
    viewBox: "0 0 3.7820311 5.9773459",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-53.877791,-96.589064)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m 55.83326,99.314064 q 0.523437,-0.171875 0.792968,-0.460937 0.269532,-0.292969 0.269532,-0.683594 0,-0.414063 -0.277344,-0.652344 -0.277344,-0.242187 -0.761719,-0.242187 -0.503906,0 -0.808594,0.265625 -0.304687,0.261718 -0.304687,0.699218 0,0.398438 0.273437,0.667969 0.277344,0.265625 0.816407,0.40625 z m -0.257813,0.472656 q -0.46875,0.207032 -0.691406,0.48828 -0.21875,0.27735 -0.21875,0.66406 0,0.42188 0.292969,0.67969 0.296875,0.25391 0.777343,0.25391 0.507813,0 0.824219,-0.28906 0.320313,-0.28907 0.320313,-0.74219 0,-0.375 -0.292969,-0.61328 -0.289063,-0.242191 -1.011719,-0.44141 z m 0.832031,-0.265625 q 0.589844,0.175782 0.867188,0.484375 0.277344,0.30469 0.277344,0.78125 0,0.73438 -0.527344,1.20703 -0.523438,0.47266 -1.351563,0.47266 -0.765625,0 -1.230468,-0.40235 -0.464844,-0.40234 -0.464844,-1.0625 0,-0.48046 0.269531,-0.83203 0.269531,-0.355466 0.800781,-0.574216 -0.496093,-0.222656 -0.746093,-0.558594 -0.246094,-0.339843 -0.246094,-0.804687 0,-0.6875 0.507812,-1.113281 0.511719,-0.429688 1.339844,-0.429688 0.757813,0 1.207031,0.378906 0.449219,0.378907 0.449219,1.011719 0,0.492188 -0.289062,0.855469 -0.285157,0.359375 -0.863282,0.585937 z",
    style: {
      fontSize: 8,
      fontFamily: "'Maiandra GD'",
      InkscapeFontSpecification: "'Maiandra GD, Normal'",
      stroke: "#000000",
      strokeWidth: 0.2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigit8);
export default __webpack_public_path__ + "static/media/digit-8.4222f7e9cd4287708d27910f6363a911.svg";
export { ForwardRef as ReactComponent };